import React, { useContext } from 'react';
import { useFormik } from 'formik';
import { Box } from '@mui/material';
import nameValidationSchema from '../helpers/validationSchema';
import CategoriesForm from './CategoriesForm';
import { SidekickTablesContext } from '../../helpers/SidekickTablesContext';
import { Category } from '../../helpers/types';

const EditCategoryCard = ({
  currentObject,
  resetObject,
}: {
  currentObject: Category;
  resetObject: () => void;
}) => {
  const { updateObject } = useContext(SidekickTablesContext);

  const formik = useFormik({
    initialValues: {
      ...currentObject,
    },
    validationSchema: nameValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, actions) => {
      const valuesToCast = {
        name: values.name,
      };

      const requestValues: Category = {
        ...values,
        ...nameValidationSchema.cast(valuesToCast),
      };

      actions.setSubmitting(false);
      updateObject(requestValues);
    },
  });

  return (
    <Box padding={2} paddingTop={3} marginTop={7} sx={{ mb: '65px', overflow: 'auto' }}>
      <CategoriesForm
        formik={formik}
        cancelAction={() => {
          resetObject();
        }}
        objectId={currentObject.id.toString()}
      />
    </Box>
  );
};

export default EditCategoryCard;
